import * as React from "react";
import classnames from "classnames";
import { MediaQuery, RichTextArea } from "@grandvisionhq/common";
/* empty css                              */
const PupillaryDistanceContent = ({ className, description, image }) => {
  const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
  return /* @__PURE__ */ React.createElement("section", { className: classnames("pupillary-distance-content", className) }, image && /* @__PURE__ */ React.createElement(
    "img",
    {
      className: "pupillary-distance-content__image",
      src: isSmallScreen ? image.mobileUrl : image.url,
      alt: image.description || ""
    }
  ), description && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(RichTextArea, { className: "pupillary-distance-content__description", content: description })));
};
export {
  PupillaryDistanceContent
};
//# sourceMappingURL=PupillaryDistanceContent.js.map
